<template>
  <div>
    <div :class="customer">
      <pre v-text="messageText"></pre>
    </div>
  </div>
</template>

<script>
//import escapeGoat from 'escape-goat'
import Autolinker from "autolinker";
import Global from "@/components/Global";
export default {
  props: ["data"],
  computed: {
    customer() {    
      let result = false;
      result = this.data.senderType === 1;
      return result
        ? "message my-message"
        : "message other-message float-right";
    },
    messageText() {
      return this.data.Text;
      //  return Autolinker.link(escapeGoat.escape(this.data.Text), {
      //    className: 'chatLink',
      //    truncate: { length: 50, location: 'smart' }
      // })
    }
  }
};
</script>
<style>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/TextMessage.vue